import React, { Fragment, useEffect, useState } from "react";
import { getBigLeagueCnt, isEmpty, onErrorImg } from "../../../common/cores";
import connect from "react-redux/lib/connect/connect";
import { resource_url } from "../../../common/cores/keys";
import {
  ClearSportsList,
  SetClicked,
  SetLeague,
  SetLocation,
  SetSearchType,
  SetSearchValue,
  SetSportId,
} from "../../../common/actions/sportsAction";
import { SetCurrentPage } from "../../../common/actions/pageAction";

const BigLeague = (props) => {
  const { sports, page } = props;
  const { type, title, view } = props;
  const [bigleagueLists, setBigLeagueLists] = useState("");
  const [clickedLeagueId, setClickedLeagueId] = useState("");
  // console.log('bigleagueLists: ', bigleagueLists);
  useEffect(() => {}, []);

  useEffect(() => {
    let Lists = getBigLeagueCnt(type);
    setBigLeagueLists(Lists);
  }, [sports.bigleagueCnt, page.pageInfo.gameType, type]);

  const onLeague = (league) => {
    if (league.id != clickedLeagueId) {
      props.ClearSportsList();
      setClickedLeagueId(league.id);
    }
    props.SetSportId(league.sport_id);
    props.SetLeague(league.id);
    props.SetLocation("all");
    props.SetSearchType("");
    props.SetSearchValue("");
    props.SetClicked(true);
    props.SetCurrentPage({ page: 1, totalPage: 50 });
  };

  return (
    !isEmpty(bigleagueLists) && (
      <Fragment>
        <div className="left_game_tab" style={{ marginTop: "15px" }}>
          <ul>
            <li className="active">
              <a>
                {isEmpty(window.lang["리그"]) ? "리그" : window.lang["리그"]}
                <span></span>
              </a>
            </li>
          </ul>
        </div>
        <div className="left_game_list">
          {!isEmpty(bigleagueLists) &&
            bigleagueLists.map((list, index) => {
              return (
                <Fragment key={index}>
                  <div
                    className="sports_events_menu"
                    onClick={() => {
                      onLeague(list);
                      view();
                    }}
                  >
                    <img
                      src={
                        isEmpty(list.id)
                          ? "../images/248.png"
                          : resource_url +
                            "/images/locations/" +
                            list.id +
                            ".png"
                      }
                      className="sports_country_img"
                      style={{ width: "25px", borderRadius: "unset" }}
                    />
                    <img
                      src="../images/common/arrow_01.png"
                      className="arrow"
                      alt=""
                    />
                    {list.name_kor}
                    <span className="sports_event_odd_big">{list.count}</span>
                    {/* <span className="sports_event_arrow">
                                        <i className="fa-solid fa-angle-down"></i>
                                    </span> */}
                  </div>
                </Fragment>
              );
            })}
        </div>
      </Fragment>
    )
  );
};

const mapStateToProps = (state) => ({
  sports: state.sports,
  page: state.page,
});

export default connect(mapStateToProps, {
  SetSportId,
  ClearSportsList,
  SetLeague,
  SetLocation,
  SetCurrentPage,
  ClearSportsList,
  SetSearchType,
  SetSearchValue,
  SetClicked,
})(BigLeague);



// WEBPACK FOOTER //
// ./src/components/sports/sportscomponent/BigLeague.js